import './App.css';

import React, {useRef, useState} from 'react'
import Typed from 'typed.js'



function TypingComponent () {
  const [showElements, setShowElements] = useState(false);
  const Strings = ["Github.com/Tzoofe", "Twitter.com/Tzoofe", "Doing nothing atm, CS Student at Ariel University", ":^)"]; 
  const el = React.useRef(null);
  const typingStyle = {
    color: "white",
    fontSize: "40px",
    fontFamily: "Bitcount Prop Single"
  }
  const elementsStyle = {
    color: "white",
    fontSize: "30px",
    fontFamily: "Bitcount Prop Single",

  }
  React.useEffect(() => {
    const options = {
      strings: Strings,
      typeSpeed: 70,
      loop: false,
      onComplete: () => {
        setShowElements(true);

      }

    }
      const typed = new Typed(el.current, options);
      return () => {
        typed.destroy();
    };
  }, []);
    return (
    <div className="App">
      <div>
        <span style={typingStyle} ref={el} />
      </div>
      <div style={elementsStyle} className={`fade-in-container ${showElements ? 'visible' : ''}`}>
        {showElements && (
            <ul style={{listStyleType: "none"}}>
              <li style={{paddingBottom: "20px"}}><a style={{textDecoration: "none", color: "white"}} href="https://github.com/tzoofe">Github</a></li>
              <li style={{paddingBottom: "20px"}}><a style={{textDecoration: "none", color: "white"}} href='tzoofe@gmail.com'>Contact</a></li>
            </ul>
        )}
      </div>

    </div>
  );
}

function App() {
  return (
    <div className="App">

      <TypingComponent/>
    </div>
  );
  
}

export default App;